import { useContext, useLayoutEffect, useRef, useState } from "react";
import { BurgerButtonBig, ButtonRound, HeaderBig, LearnMore } from "../common/Common";
import './AboutUs.css';
import { LocaleContext, ScrollContext } from "../common/App";
import { Footer } from "./WebsiteCommon";

export function AboutUs(props) {
    const locale = useContext(LocaleContext);

    return (
        <div>
            <img className="img_width" src="/customer/header_about-us.jpg"></img>
            <div className="text_box">
                <div className="text_small">{locale.msgs.ABOUT_US}</div>

                <div className="text_big_big margin_top_middle">{locale.msgs.BROKERAGE_WITH_HEART}</div>
                <div className="text" dangerouslySetInnerHTML={{__html: locale.msgs.BROKERAGE_WITH_HEART_DESCR}}></div>
            </div>

            <div id="team_box">
                <div className="text_big_big">{locale.msgs.M_N_TEAM}</div>

                <MainTeamMember img="/customer/nadja.jpg" name={locale.msgs.TEAM_MEMBER_NADJA_NAME} role={locale.msgs.TEAM_MEMBER_NADJA_ROLE} text={locale.msgs.TEAM_MEMBER_NADJA_TEXT} />
                <MainTeamMember img="/customer/tommy.jpg" name={locale.msgs.TEAM_MEMBER_TOMMY_NAME} role={locale.msgs.TEAM_MEMBER_TOMMY_ROLE} text={locale.msgs.TEAM_MEMBER_TOMMY_TEXT} />
                <MainTeamMember img="/customer/nelly.jpg" name={locale.msgs.TEAM_MEMBER_NELLY_NAME} role={locale.msgs.TEAM_MEMBER_NELLY_ROLE} text={locale.msgs.TEAM_MEMBER_NELLY_TEXT} />
                <MainTeamMember img="/customer/fritz.jpg" name={locale.msgs.TEAM_MEMBER_FRITZ_NAME} role={locale.msgs.TEAM_MEMBER_FRITZ_ROLE} text={locale.msgs.TEAM_MEMBER_FRITZ_TEXT} />
                <MainTeamMember img="/customer/maike.jpg" name={locale.msgs.TEAM_MEMBER_MAIKE_NAME} role={locale.msgs.TEAM_MEMBER_MAIKE_ROLE} text={locale.msgs.TEAM_MEMBER_MAIKE_TEXT} />
                <MainTeamMember img="/customer/ivo.jpg" name={locale.msgs.TEAM_MEMBER_IVO_NAME} role={locale.msgs.TEAM_MEMBER_IVO_ROLE} text={locale.msgs.TEAM_MEMBER_IVO_TEXT} />
                <MainTeamMember img="/customer/tobi.jpg" name={locale.msgs.TEAM_MEMBER_TOBI_NAME} role={locale.msgs.TEAM_MEMBER_TOBI_ROLE} text={locale.msgs.TEAM_MEMBER_TOBI_TEXT} />

                {/*
                <div className="other_team_member_box">
                    <OtherTeamMember img="./nadja.PNG"/>
                    <OtherTeamMember img="./nadja.PNG"/>
                    <OtherTeamMember img="./nadja.PNG"/>
                    <OtherTeamMember img="./nadja.PNG"/>
                </div>
                */}

            </div>

            <Footer />
        </div>
    );
}

export function MainTeamMember(props) {
    const mainTeamMemberImgRef = useRef();
    const [mainTeamMemberHeight, setMainTeamMemberHeight] = useState(0);
    const [imageLoaded, setImageLoaded] = useState(false);

    useLayoutEffect(() => {
        function setImgWidth() {
            setMainTeamMemberHeight(mainTeamMemberImgRef.current.clientWidth);
        }

        setImgWidth();

        window.addEventListener("resize", setImgWidth);
        return () => window.removeEventListener("resize", setImgWidth);
    }, [imageLoaded]);

    return (
        <div className="main_team_member">
            <img ref={mainTeamMemberImgRef} className="main_team_member_img" src={props.img} style={{height: mainTeamMemberHeight}}
                    onLoad={(e) => setImageLoaded(true)}></img>
            <div className="main_team_member_name" dangerouslySetInnerHTML={{__html: props.name}}></div>
            <div className="main_team_member_role" dangerouslySetInnerHTML={{__html: props.role}}></div>
            <div className="main_team_member_text text" dangerouslySetInnerHTML={{__html: props.text}}></div>
        </div>
    );
}

export function OtherTeamMember(props) {
    const locale = useContext(LocaleContext);
    const [imgHeight, setImgHeight] = useState(0);
    const [imageLoaded, setImageLoaded] = useState(false);
    const imgRef = useRef();

    useLayoutEffect(() => {
        function setImgWidth() {
            setImgHeight(imgRef.current.clientWidth);
        }

        setImgWidth();

        window.addEventListener("resize", setImgWidth);
        return () => window.removeEventListener("resize", setImgWidth);
    }, [imageLoaded]);

    return (
        <div className="other_team_member">
            <img ref={imgRef} style={{height: imgHeight}} className="other_team_member_img" src={props.img} onLoad={(e) => setImageLoaded(true)}></img>
            <div className="other_team_member_name">{locale.msgs.MAIN_TEAM_MEMBER_NAME}</div>
            <div className="other_team_member_role">{locale.msgs.MAIN_TEAM_MEMBER_ROLE}</div>
        </div>
    )
}
